import React, { useState, useRef, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Space,
  Table,
  Modal,
  Image,
  Select,
  message,
  // Upload,
  DatePicker,
  Radio,
  Tag,
  Spin,
} from "antd";
import { LoadingOutlined, PlusOutlined, LayoutFilled } from "@ant-design/icons";
import zh from "antd/es/date-picker/locale/zh_CN";
import baseRequest from "../../utils/baseRequest";
import ImageUploader from "../../components/ImageUploader";
import PagesManage from "../../components/PagesManage";
import { useMemo } from "react";
import dayjs from "dayjs";
import debounce from "lodash/debounce";
import { DeleteFilled } from "@ant-design/icons";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
const NoticesContent = (props) => {
  const [messageApi, contextHolder] = message.useMessage();
  //控制创建动态modal是否出现
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPagesModalOpen, setIsPagesModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [assets, setAssets] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  //提交创建动态
  const [form] = Form.useForm();
  const [pagesOptions, setPagesOptions] = useState([]);
  const [pathMethod, setPathMethod] = useState("");
  const [selectedStreamer, setSelectedStreamer] = useState(null);
  const { TextArea } = Input;
  const current = props.current;
  const [zones, setZones] = useState(null);
  const [displayImageId, setDisplayImageId] = useState([]);
  //表头
  const columns = [
    {
      width: 100,
      fixed: "left",
      title: "推送消息类型",
      dataIndex: "n_type",
      key: "n_type",
      filters: [
        {
          text: "系统通知",
          value: 0,
        },
        {
          text: "审核通知",
          value: 1,
        },
        {
          text: "付费消息",
          value: 2,
        },
        {
          text: "活动消息",
          value: 3,
        },
      ],
      filterMode: "tree",
      onFilter: (value, record) => record.n_type === value,
      render: (data) => {
        return (
          <div>
            {data == 0
              ? "系统通知"
              : data == 1
              ? "审核通知"
              : data == 2
              ? "付费消息"
              : "活动消息"}
          </div>
        );
      },
    },
    {
      title: "通知标题",
      dataIndex: "title",
      key: "title",
      width: 150,
    },
    {
      title: "推送消息正文",
      dataIndex: "message",
      key: "message",
      width: 200,
    },
    {
      title: "推送消息主图",
      dataIndex: "thumbnail",
      key: "thumbnail",
      width: 150,
      render: (data) => (
        <div>
          {data
            ? data.images?.map((item, index) => (
                <Image
                  key={index}
                  src={item.urls[0]}
                  style={{ marginBottom: 10 }}
                />
              ))
            : "-"}
        </div>
      ),
    },
    {
      title: "链接标语",
      width: 120,
      dataIndex: "link_text",
      key: "link_text",
      render: (data) => <div>{data || "-"}</div>,
    },
    {
      width: 200,
      title: "链接",
      dataIndex: "hyperlinks",
      key: "hyperlinks",
      render: (data) => {
        if (!data) return "-";
        return (
          <div className="flex flex-col flex-wrap gap-1">
            {data.map((hyperlink, index) => (
              <div key={index}>
                <p className="text-[#00000080]">
                  {hyperlink.action === "outward"
                    ? "外部链接:"
                    : hyperlink.action === "webViewHeaderInward"
                    ? "应用内打开内链（带头）:"
                    : hyperlink.action === "webViewHeaderOutward"
                    ? "应用内打开外链（带头）:"
                    : hyperlink.action === "webViewWithOutHeaderInward"
                    ? "应用内打开内链（不带头）:"
                    : hyperlink.action === "webViewWithOutHeaderOutward"
                    ? "应用内打开外链（不带头）:"
                    : index
                    ? "H5:"
                    : "App:"}
                </p>
                {hyperlink.action === "outward" ? (
                  <a href={hyperlink.params} target="_blank">
                    {hyperlink.params}
                  </a>
                ) : (
                  <span>{hyperlink.params}</span>
                )}
              </div>
            ))}
          </div>
        );
      },
    },
    {
      width: 150,
      title: "推送时间",
      dataIndex: "push_time",
      key: "push_time",
      render: (data, record) => {
        return (
          <div>
            {dayjs(!!data ? data * 1000 : record.ct * 1000).format(
              "YYYY-MM-DD HH:mm:ss"
            )}
          </div>
        );
      },
    },
    {
      width: 150,
      title: "推送角色",
      dataIndex: "obj_user_ids",
      key: "obj_user_ids",
      render: (data) => (
        <div className="overflow-auto max-h-32">
          {data?.length > 0
            ? data.map((it) => (
                <Tag className="mb-2" key={it}>
                  {it}
                </Tag>
              ))
            : "-"}
        </div>
      ),
    },
    {
      width: 120,
      title: "推送角色类型",
      dataIndex: "obj_type",
      key: "obj_type",
      render: (data) => {
        return (
          <div>
            {data == 0
              ? "所有达人"
              : data == 1
              ? "所有普通用户"
              : data == 2
              ? "全部"
              : "自定义角色"}
          </div>
        );
      },
    },
    {
      width: 120,
      title: "推送状态",
      dataIndex: "status",
      key: "status",
      filters: [
        {
          text: "待推送",
          value: 0,
        },
        {
          text: "已推送",
          value: 1,
        },
        {
          text: "推送失败",
          value: 2,
        },
        {
          text: "已撤销",
          value: 3,
        },
      ],
      filterMode: "tree",
      fixed: "right",
      onFilter: (value, record) => record.status == value,
      render: (data) => (
        <div>
          {data == 0 ? (
            <Tag color="green">待推送</Tag>
          ) : data == 1 ? (
            <Tag color="blue">已推送</Tag>
          ) : data == 2 ? (
            <Tag color="red">推送失败</Tag>
          ) : (
            <Tag color="orange">已撤销</Tag>
          )}
        </div>
      ),
    },
    {
      title: "操作",
      dataIndex: "opeartion",
      key: "opeartion",
      fixed: "right",
      render: (_, record) => {
        return (
          <div>
            <Space>
              <Space.Compact direction="vertical">
                {record.status == 0 && (
                  <Button
                    style={{ background: "#ff4d4f", color: "#fff" }}
                    onClick={() => handleCancleNotice(record?.id)}
                  >
                    撤销通知
                  </Button>
                )}
              </Space.Compact>
            </Space>
          </div>
        );
      },
    },
  ];
  //给表单绑定ref
  const formRef = useRef(null);
  useEffect(() => {
    getPages();
  }, []);
  //创建页面路由
  const getPages = async () => {
    try {
      const base = baseRequest();
      const response = await fetch("/op/frontend_route/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          offset: 0,
          limit: 10,
          ...base,
        }),
      });
      const _data = await response.json();
      if (_data.ret === -1) {
        alert(_data.msg);
        return;
      }
      setPagesOptions(_data.data.list);
    } catch (error) {
      console.error(error);
    }
  };
  //点击修改状态按钮
  const onClickSubmit = (record) => {
    formRef.current.key = record.key;
    formRef.current.btn = "submit";
    formRef.current.submit();
  };
  //点击无效按钮
  const onClickInvalid = (record) => {
    formRef.current.key = record.key;
    formRef.current.btn = "invalid";
    formRef.current.submit();
  };
  //点击迭代相关按钮
  const onClickIteration = (record) => {
    formRef.current.key = record.key;
    formRef.current.btn = "iteration";
    formRef.current.submit();
  };
  //通知撤销
  const handleCancleNotice = async (nid) => {
    try {
      const base = baseRequest();
      const response = await fetch("/op/notification/cancel", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          nid,
          ...base,
        }),
      });
      const temData = await response.json();
      if (temData.ret === -1) {
        alert(temData.msg);
        return;
      }
      message.success("撤销成功");
    } catch (error) {
      console.error(error);
    }
  };
  const buddhistLocale = {
    ...zh,
    lang: {
      ...zh.lang,
      fieldDateFormat: "YYYY-MM-DD",
      fieldDateTimeFormat: "YYYY-MM-DD HH:mm",
      yearFormat: "YYYY",
      cellYearFormat: "YYYY",
    },
  };
  //获取数据
  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [more, setMore] = useState(1);
  const [total, setTotal] = useState(0);
  const [formData, setFormData] = useState({
    title: "",
    message: "",
    n_type: 0,
    obj_user_ids: [],
    push_time: dayjs(new Date()),
    params: "",
    pageName: null,
    link: null,
    action: null,
    link_text: null,
    thumbnail: null,
    obj_type: "0",
  });
  const [currentPageName, setCurrentPageName] = useState("");
  const [buttonAble, setButtonAble] = useState(false);

  const currentPagesOptions = useMemo(() => {
    if (!pagesOptions.length) return [];
    const pages = pagesOptions
      .filter((it) => it.desc === "达人空间")
      .map((it) => {
        return {
          label: it.desc,
          value: JSON.stringify(it),
        };
      });
    return pages;
  }, [pagesOptions, formData.action]);

  const getData = async (offset) => {
    if (!more) return;
    let querryStatus;
    switch (current) {
      case "pushing":
        querryStatus = 0;
        break;
      case "pushed":
        querryStatus = 1;
        break;
      case "fail":
        querryStatus = 2;
        break;
      case "backed":
        querryStatus = 3;
        break;
      default:
        break;
    }
    try {
      const base = baseRequest();
      const response = await fetch("/op/notification/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          n_types: [0, 1, 2, 3],
          push_type: 1,
          status: querryStatus,
          offset: 0,
          limit: 20 + offset,
          ...base,
        }),
      });
      const temData = await response.json();
      console.log("response", temData);

      if (temData.ret === -1) {
        alert(temData.msg);
        return;
      }
      setShowData([...temData.data.list]);
      if (temData.data.offset > total) {
        setTotal(temData.data.offset);
      }
      setOffset(temData.data.offset);
      setMore(temData.data.more);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getData(0);
  }, [current]);

  //展示的数据
  const [showData, setShowData] = useState(data);

  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  //关闭弹窗
  const handleCancelModal = () => {
    form.setFieldsValue(formData);
    setPathMethod("");
    setSelectedStreamer(null);
    setIsModalOpen(false);
    setZones(null);
    setDisplayImageId([]);
  };
  const handleSubmit = async (value) => {
    // if (!selectedUser) {
    //   alert("还未选中用户");
    //   return;
    // }
    const {
      action,
      params,
      status,
      link,
      hyperlinks,
      pageName,
      obj_user_ids,
      push_time,
      obj_type,
      id,
      thumbnail,
    } = value;
    const obj_midsArr = obj_user_ids?.split(" ").map((it) => Number(it));
    let newHyperlinks = [];
    if (hyperlinks) {
      newHyperlinks = hyperlinks;
    } else {
      const paramsObj = pageName ? JSON.parse(pageName) : null;
      newHyperlinks = paramsObj
        ? [
            {
              params: paramsObj.app_route_path.replace("MID", value.mid),
              action,
              frontend_route_id: paramsObj.id,
              inward_action_type: "app",
            },
            {
              params: paramsObj.h5_route_path.replace("[mid]", value.mid),
              action,
              frontend_route_id: paramsObj.id,
              inward_action_type: "h5",
            },
          ]
        : action
        ? [
            {
              params: link,
              action,
              inward_action_type: "outward",
            },
          ]
        : null;
    }

    if (!id) {
      if (!status && new Date(push_time).getTime() < new Date().getTime()) {
        messageApi.open({
          type: "warning",
          content: "推送时间不能早于当前时间",
        });
        return;
      }
    }
    try {
      const base = baseRequest();
      const response = await fetch(`/op/notification/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...value,
          obj_user_ids: obj_midsArr,
          push_time:
            Math.floor(new Date(push_time).getTime() / (60 * 1000)) * 60,
          obj_type: parseInt(obj_type, 10),
          hyperlinks: newHyperlinks,
          sub_mid: 0,
          thumbnail: thumbnail?.images
            ? thumbnail
            : { image_ids: displayImageId },
          ...base,
        }),
      });
      const data = await response.json();
      if (data.ret === -1) {
        alert(data.msg);
        return;
      }
      handleCancelModal();
      message.success("发布成功");
    } catch (error) {
      console.error(error);
    }

    form.resetFields();
  };
  const onTimeOk = (value) => {
    console.log("onOk: ", value);
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        上传图片
      </div>
    </button>
  );
  const findBracketedFields = (text) => {
    const regex = /\[(.*?)\]/g;
    const matches = [];
    let match;

    while ((match = regex.exec(text)) !== null) {
      matches.push(match[1]);
    }

    return matches;
  };
  const splitParams = useMemo(() => {
    const newCurrentPageName = form.getFieldValue("pageName");
    if (!newCurrentPageName) return [];
    const CurrentPageNameObj = JSON.parse(newCurrentPageName);
    const { app_route_path, h5_route_path } = CurrentPageNameObj;
    const newCurrentPageNameStr = app_route_path || h5_route_path;
    if (
      newCurrentPageNameStr.indexOf("?") !== -1 ||
      newCurrentPageNameStr.indexOf("[") !== -1
    ) {
      if (newCurrentPageNameStr.indexOf("?") !== -1) {
        const splitParamsStr = newCurrentPageNameStr.split("?")[1];
        return splitParamsStr.split("&").map((item) => item.split("=")[0]);
      }
      // const regex = /\[.*?\]/g;
      if (newCurrentPageNameStr) {
        // const matches = [];
        // let match;
        // while ((match = regex.exec(newCurrentPageNameStr)) !== null) {
        //   matches.push(match[1]);
        //   console.log("Regex: ", match[1]);
        // }
        const matches = findBracketedFields(newCurrentPageNameStr);
        console.log("Regex: ", matches);
        return matches;
      } else {
        return [];
      }
    } else {
      return [];
    }
  }, [currentPageName]);
  //搜索空间
  const handleSearchMid = async (mid) => {
    // const mid = form.getFieldValue("mid");
    if (!mid) return;
    setLoading(true);
    try {
      const base = baseRequest();
      const detailResponse = await fetch(`/op/zone/list_by_user_id`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: parseInt(mid, 10),
          ...base,
        }),
      });
      const detailData = await detailResponse.json();
      if (detailData.ret === -1) {
        alert(detailData.msg);
        return;
      }
      const zonesArr = detailData.data.list;
      setZones(zonesArr);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const currentStreamerImage = useMemo(() => {
    console.log("form.validateFields", displayImageId);
    if (selectedStreamer && zones && displayImageId.length > 0) {
      if (zones[0].streamer_ext.avatar.image_ids[0] === displayImageId[0]) {
        return zones[0]?.streamer_ext.avatar.images[0].urls[0];
      } else {
        return null;
      }
    } else {
      return null;
    }
  }, [zones, selectedStreamer, displayImageId]);
  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <div className="flex justify-between items-center">
        <Button
          type="default"
          className="mt-4 mb-4 float-right"
          onClick={() => setIsPagesModalOpen(true)}
          icon={<LayoutFilled className="text-primary" />}
        >
          页面管理
        </Button>
        <Button
          type="primary"
          className="mt-4 mb-4 float-right"
          onClick={() => setIsModalOpen(true)}
        >
          新建推送+
        </Button>
      </div>
      {contextHolder}
      <ConfigProvider locale={zhCN}>
        <Table
          columns={columns}
          dataSource={showData}
          pagination={{
            pageSize: 20,
            showSizeChanger: false,
            total: total,
          }}
          scroll={{ x: "max-content", y: window.innerHeight - 280 }}
          footer={() => (
            <div className="text-gray-400">获得总数：{showData.length}</div>
          )}
          onScroll={(e) => {
            const { scrollHeight, scrollTop, clientHeight } = e.currentTarget;
            if (scrollTop + clientHeight + 5 >= scrollHeight) {
              getData(offset);
            }
          }}
        />
      </ConfigProvider>

      {/* 重复判断isModalOpen是为了重新渲染ImageUploader和VideoUploader组件 */}
      <Modal
        title="新建消息推送通知"
        footer={null}
        open={isModalOpen}
        onCancel={handleCancelModal}
        onChange={setFormData}
      >
        <Form
          className="mt-4 flex flex-col"
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          initialValues={formData}
          onChange={setFormData}
        >
          <Form.Item
            label="通知标题"
            name="title"
            rules={[
              {
                required: true,
                message: "请填写通知标题",
              },
            ]}
            className="mb-6"
          >
            <Input maxLength={10} placeholder="字数上限为10" />
          </Form.Item>
          <Form.Item
            label="添加活动消息正文（上限250字）"
            name="message"
            rules={[
              {
                required: true,
                message: "请填写活动消息内容",
              },
            ]}
            className="mb-6"
          >
            <TextArea maxLength={250} showCount placeholder="字数上限为250" />
          </Form.Item>
          <Form.Item
            label="推送消息类型"
            name="n_type"
            rules={[
              {
                required: true,
                message: "请选择推送消息类型",
              },
            ]}
            className="mb-6"
          >
            <Select
              // defaultValue={1}
              style={{
                width: 120,
              }}
              // onChange={handleChange}
              options={[
                {
                  value: 0,
                  label: "系统通知",
                },
                {
                  value: 1,
                  label: "审核通知",
                },
                {
                  value: 2,
                  label: "付费消息",
                },
                {
                  value: 3,
                  label: "活动消息",
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            label="推送角色"
            name="obj_type"
            rules={[
              {
                required: true,
                message: "请填写推送角色",
              },
            ]}
            className={formData.obj_type == 3 ? "mb-2" : "mb-6"}
          >
            <Radio.Group>
              <Radio value={0}>所有达人</Radio>
              <Radio value={1}>所有普通用户</Radio>
              <Radio value={2}>全部</Radio>
              <Radio value={3}>自定义角色</Radio>
            </Radio.Group>
          </Form.Item>
          {form.getFieldValue("obj_type") == 3 && (
            <Form.Item
              name="obj_user_ids"
              rules={[
                {
                  required: true,
                  message: "请填写推送角色",
                },
              ]}
              className="mb-6"
            >
              <div>
                <TextArea
                  value={formData.obj_user_ids}
                  placeholder="用户ID以空格隔开"
                />
              </div>
            </Form.Item>
          )}

          <Form.Item
            label="推送时间"
            name="push_time"
            format="YYYY-MM-DD HH:mm"
            rules={[
              {
                required: true,
                message: "请选择时间",
              },
            ]}
            className="mb-6"
          >
            <DatePicker
              // showNow={false}
              showTime
              minDate={dayjs(new Date())}
              // locale={{
              //   lang: { locale: "zh_CN", placeholder: "选择日期时间" },
              // }}
              locale={buddhistLocale}
              onChange={(v) => console.log(v)}
              onOk={onTimeOk}
            />
          </Form.Item>
          <p className="mb-2">添加跳转内容：</p>
          <Space
            direction="vertical"
            className="bg-[#00000011] rounded-md p-4 mb-4"
          >
            <Form.Item label="跳转形式" name="action">
              <Select
                placeholder="选择跳转形式"
                allowClear
                style={{
                  width: 240,
                }}
                onChange={(e) => {
                  form.setFieldsValue({
                    pageName: "",
                    link: "",
                    params: "",
                    hyperlinks: "",
                    mid: null,
                  });
                  setPathMethod(e);
                }}
                options={[
                  {
                    value: "inward",
                    label: "达人空间跳转",
                  },
                  {
                    value: "outward",
                    label: "打开新的浏览器页面",
                  },
                  {
                    value: "webViewHeaderOutward",
                    label: "应用内打开外链（带头）",
                  },
                  {
                    value: "webViewHeaderInward",
                    label: "应用内打开内链（带头）",
                  },
                  {
                    value: "webViewWithOutHeaderOutward",
                    label: "应用内打开外链（不带头）",
                  },
                  {
                    value: "webViewWithOutHeaderInward",
                    label: "应用内打开内链（不带头）",
                  },
                ]}
              />
            </Form.Item>

            <div>
              <div>
                <div
                  style={{
                    display:
                      pathMethod !== "inward" && pathMethod ? "block" : "none",
                  }}
                >
                  <Form.Item
                    rules={[
                      {
                        required: pathMethod !== "inward" && pathMethod,
                        message: "请填写具体链接地址",
                        pattern: /^(https?:\/\/).*$/,
                      },
                    ]}
                    label="跳转位置"
                    name="link"
                    className="mb-2"
                  >
                    <Input placeholder="填写外部跳转链接，如：https://..." />
                  </Form.Item>
                </div>
                <Space
                  direction="vertical"
                  className="w-full"
                  style={{
                    display: pathMethod == "inward" ? "block" : "none",
                  }}
                >
                  <label>
                    <span className="text-[red] mr-1">*</span>跳转位置
                  </label>
                  <div className="grid grid-cols-2 items-start">
                    <Space align="center">
                      <Form.Item
                        name="pageName"
                        className="mb-2"
                        rules={[
                          {
                            required: pathMethod == "inward",
                            message: `请选择页面`,
                          },
                        ]}
                      >
                        <Select
                          placeholder="选择页面"
                          style={{
                            width: 160,
                          }}
                          onChange={setCurrentPageName}
                        >
                          {currentPagesOptions.length > 0 &&
                            currentPagesOptions.map((it) => {
                              return (
                                <Select.Option key={it.id} value={it.value}>
                                  {it.label}
                                </Select.Option>
                              );
                            })}
                          {/* <Select.Option value={1}>x1</Select.Option>
                            <Select.Option value={2}>x2</Select.Option>
                            <Select.Option value={3}>x3</Select.Option>
                            <Select.Option value={5}>x5</Select.Option> */}
                        </Select>
                      </Form.Item>
                      <div className="-mt-2 mx-2">?</div>
                    </Space>
                    <Space
                      direction="vertical"
                      className="bg-white rounded-xl p-4"
                    >
                      <Select
                        // style={{
                        //   width: 240,
                        // }}
                        className="w-full"
                        showSearch
                        allowClear
                        placeholder="通过ID搜索达人"
                        // optionFilterProp="label"
                        onChange={(v) => {
                          const currentIt = zones?.filter(
                            (it) => it.mid == v
                          )[0];
                          if (currentIt) {
                            setSelectedStreamer(currentIt);
                            setDisplayImageId(
                              currentIt.streamer_ext.avatar.image_ids
                            );
                            form.setFieldsValue({
                              mid: v,
                              title:
                                form.getFieldValue("title") ||
                                currentIt.streamer_ext.name,
                              // image: displayImageId[0] || currentIt.streamer_ext.avatar,
                              text:
                                form.getFieldValue("text") || currentIt.profile,
                            });
                          } else {
                            setSelectedStreamer(null);
                            form.setFieldsValue({
                              mid: null,
                            });
                          }
                        }}
                        filterOption={false}
                        onSearch={debounce(handleSearchMid, 1000)}
                        notFoundContent={loading ? <Spin size="small" /> : null}
                        options={zones?.map((it) => ({
                          value: it.mid,
                          label: (
                            <div>
                              <p className="font-bold w-1/4">ID：{it?.mid}</p>
                              <p className="font-bold w-3/4">
                                昵称：{it?.streamer_ext.name}
                              </p>
                            </div>
                          ),
                        }))}
                        labelRender={({ value }) => {
                          const currentIt = zones?.filter(
                            (it) => it.mid == value
                          )[0];
                          if (currentIt) {
                            return currentIt.streamer_ext.name;
                          }
                          return <span>No option match</span>;
                        }}
                      />
                      {splitParams.map((it) => (
                        <Form.Item
                          name={it}
                          className="mb-2"
                          rules={[
                            {
                              required: pathMethod == "inward",
                              message: `请填写${it}的值`,
                            },
                          ]}
                        >
                          <div className="px-2 py-1 rounded bg-[#93939340]">
                            {it}：{selectedStreamer?.mid}
                          </div>
                          <Input
                            disabled
                            className="bg-gray-200 hidden"
                            placeholder="参数值"
                            prefix={<span>{it}：</span>}
                            value={selectedStreamer?.mid}
                          />
                        </Form.Item>
                      ))}
                    </Space>
                  </div>
                </Space>
                <div
                  style={{
                    display: pathMethod ? "block" : "none",
                  }}
                >
                  <Form.Item
                    label="跳转位置标题"
                    name="link_text"
                    rules={[
                      {
                        required: pathMethod,
                        message: "请填写链接标题",
                      },
                    ]}
                    className="mb-2"
                  >
                    <Input placeholder="链接标题" maxLength={10} />
                  </Form.Item>
                  <Form.Item
                    label="添加主图"
                    name="thumbnail"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "请上传主图",
                    //   },
                    // ]}
                    className="mb-2"
                  >
                    <div className="relative inline-block group">
                      {currentStreamerImage ? (
                        <Image
                          src={currentStreamerImage}
                          width={100}
                          className="m-[5px] rounded-[8px]"
                        />
                      ) : (
                        <ImageUploader
                          setIds={setDisplayImageId}
                          ids={displayImageId}
                          uploadOne={true}
                          preventEvent={setButtonAble}
                        />
                      )}
                      <div
                        style={{
                          visibility: displayImageId.length
                            ? "visible"
                            : "hidden",
                        }}
                        className="absolute top-4 -right-3 -mt-4 px-1 hidden rounded-full cursor-pointer bg-[#ffeceb] text-[#ff7875] group-hover:block hover:scale-125"
                        onClick={() => setDisplayImageId([])}
                      >
                        <DeleteFilled />
                      </div>
                    </div>
                  </Form.Item>
                </div>
              </div>
            </div>
          </Space>
          <Button type="primary" htmlType="submit" disabled={buttonAble}>
            确认
          </Button>
        </Form>
      </Modal>
      <Modal
        title="页面管理"
        footer={null}
        open={isPagesModalOpen}
        style={{ minWidth: 800 }}
        onCancel={() => setIsPagesModalOpen(false)}
      >
        <PagesManage />
      </Modal>
    </div>
  );
};

export default function Notices() {
  return (
    <div>
      <NoticesContent />
    </div>
  );
}
